import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArticleThumbnail from '../../components/blog/ArticleThumbnail';
import ArticleContent from '../../components/blog/ArticleThumbnailContent';
import useBlogData from '../../components/hooks/UseBlogData';
import { useMediaQueries } from '../../contexts/media-query';

const BlogTrending = () => {
  const navigate = useNavigate();
  const { isLessThan640, isLessThan899 } = useMediaQueries();

  const { blogPosts } = useBlogData('All', 1);

  const latestBlogs = blogPosts.slice(0, 3);

  const handleNavigation = (endpoint: string) => {
    navigate(endpoint);
  };
  return (
    <div className="mb-20">
      <Typography variant="h6" style={{ fontFamily: 'var(--fontPrimary)', fontSize: '24px' }}>
        Trending Blogs
      </Typography>

      {latestBlogs.map((blog: any) => {
        const { image, title, tags, content, thumbnailSnippet, slug } = blog;
        return (
          <div className="flex my-5 gap-5 cursor-pointer" key={slug} onClick={() => handleNavigation(slug)}>
            <ArticleThumbnail ratio="1/0.5" image={image} title={title} width={'180px'} />
            <div className="w-[calc(100%-180px)]">
              <ArticleContent
                className="mt-0"
                title={title}
                trending
                tags={[]}
                thumbnailSnippet={thumbnailSnippet}
                isMobile={isLessThan640}
                isTablet={isLessThan899}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BlogTrending;
